import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import GlobalSearchBox, { VisibleInContainerGlobalSearchBox } from './globalSearchBox';
import { fetchResultsBarber, fetchResults } from './actions';
import { getActiveType, getUserUrlPrefix } from '../../auth/selectors';

const UserSearchBox = ({
  userKind,
  urlPrefix,
  performBarberSearch,
  performShopSearch,
  type,
  visibleInContainerApp,
}) => {
  const SearchBox = visibleInContainerApp ? VisibleInContainerGlobalSearchBox : GlobalSearchBox;
  return (
    <SearchBox
      performSearch={userKind === 'barber' ? performBarberSearch : performShopSearch}
      urlPrefix={urlPrefix}
      type={type}
      userKind={userKind}
    />
  );
};

UserSearchBox.propTypes = {
  userKind: PropTypes.oneOf(['barber', 'shop', 'brand']).isRequired,
  performBarberSearch: PropTypes.func.isRequired,
  performShopSearch: PropTypes.func.isRequired,
  urlPrefix: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  visibleInContainerApp: PropTypes.bool,
};

UserSearchBox.defaultProps = {
  visibleInContainerApp: false,
};

const mapStateToProps = state => ({
  userKind: getActiveType(state),
  urlPrefix: getUserUrlPrefix(state),
});

const mapDispatchToProps = {
  performBarberSearch: fetchResultsBarber,
  performShopSearch: fetchResults,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSearchBox);
